import { render } from "./GuidesTitle.vue?vue&type=template&id=0e2e0256"
const script = {}
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "0e2e0256"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0e2e0256', script)) {
    api.reload('0e2e0256', script)
  }
  
  module.hot.accept("./GuidesTitle.vue?vue&type=template&id=0e2e0256", () => {
    api.rerender('0e2e0256', render)
  })

}

script.__file = "src/views/support/pageTitles/GuidesTitle.vue"

export default script